(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ritavo-wood-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__rvCardReady) return;
    window.__rvCardReady = true;
    function openCartDrawer() {
      var drawerEl = document.querySelector('cart-drawer');

      if (drawerEl) {
       
        if (typeof drawerEl.open === 'function') {
          drawerEl.open();
          return;
        }

       
        if (typeof drawerEl.setAttribute === 'function') {
          drawerEl.setAttribute('open', '');
        }
      }

     
      var events = ['cart:open', 'cart:toggle', 'CartDrawer:open'];
      events.forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });

      
      var cartToggleBtn = document.querySelector(
        '[data-cart-toggle], [aria-controls="CartDrawer"], .js-drawer-open-cart, [href="#CartDrawer"]'
      );
      if (cartToggleBtn && drawerEl && typeof drawerEl.open !== 'function') {
        cartToggleBtn.click();
      }
    }

    function getVariants(card) {
      try {
        return JSON.parse(card.querySelector('.rv-card__variants-data').textContent);
      } catch (_) {
        return [];
      }
    }

    function syncVariant(card) {
      var variants = getVariants(card);
      var selected = {};
      card.querySelectorAll('[data-rv-opt].is-active').forEach(function (btn) {
        selected[parseInt(btn.dataset.pos, 10)] = btn.dataset.val;
      });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[i + 1] === opt;
        });
      });
      if (match) {
        card.querySelector('[data-rv-variant-id]').value = match.id;
      }
    }

    function openCard(card) {
      card.classList.add('is-expanded');
      card.querySelector('[data-rv-panel]').setAttribute('aria-hidden', 'false');
    }

    function closeCard(card) {
      card.classList.remove('is-expanded');
      card.querySelector('[data-rv-panel]').setAttribute('aria-hidden', 'true');
    }

    function handleQty(btn) {
      var card  = btn.closest('[data-rv-card]');
      var input = card.querySelector('[data-rv-qty-input]');
      var next  = Math.min(99, Math.max(1, parseInt(input.value, 10) + parseInt(btn.dataset.rvDelta, 10)));
      input.value = next;
    }

    function handleATC(btn) {
      var card    = btn.closest('[data-rv-card]');
      var vid     = parseInt(card.querySelector('[data-rv-variant-id]').value, 10);
      var qty     = parseInt(card.querySelector('[data-rv-qty-input]').value, 10) || 1;
      var msgEl   = card.querySelector('[data-rv-msg]');
      var origTxt = btn.textContent;

      btn.disabled    = true;
      btn.textContent = 'Đang thêm...';
      msgEl.hidden    = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: vid, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            msgEl.textContent = data.description || 'Có lỗi xảy ra.';
            msgEl.hidden  = false;
            btn.textContent = origTxt;
            btn.disabled  = false;
          } else {
            btn.textContent = 'Đã thêm ✓';

            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
               
                document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                  el.textContent = cart.item_count;
                });

              
                document.dispatchEvent(new CustomEvent('rv:cart-updated', { detail: cart, bubbles: true }));
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

               
                openCartDrawer();
              });

            setTimeout(function () {
              btn.textContent = origTxt;
              btn.disabled  = false;
            }, 2200);
          }
        })
        .catch(function () {
          msgEl.textContent = 'Lỗi kết nối. Vui lòng thử lại.';
          msgEl.hidden  = false;
          btn.textContent = origTxt;
          btn.disabled  = false;
        });
    }

    document.addEventListener('click', function (e) {
      var selectBtn = e.target.closest('[data-rv-select]');
      if (selectBtn) { openCard(selectBtn.closest('[data-rv-card]')); return; }

      var closeBtn = e.target.closest('[data-rv-close]');
      if (closeBtn) { closeCard(closeBtn.closest('[data-rv-card]')); return; }

      var optBtn = e.target.closest('[data-rv-opt]');
      if (optBtn) {
        var card = optBtn.closest('[data-rv-card]');
        card.querySelectorAll('[data-rv-opt][data-pos="' + optBtn.dataset.pos + '"]')
          .forEach(function (b) { b.classList.remove('is-active'); });
        optBtn.classList.add('is-active');
        syncVariant(card);
        return;
      }

      var deltaBtn = e.target.closest('[data-rv-delta]');
      if (deltaBtn) { handleQty(deltaBtn); return; }

      var atcBtn = e.target.closest('[data-rv-atc]');
      if (atcBtn) { handleATC(atcBtn); return; }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-rv-card]')) {
        document.querySelectorAll('[data-rv-card].is-expanded').forEach(closeCard);
      }
    });

document.addEventListener('click', function(e) {
    const closeBtn = e.target.closest('.dongss');
    if (!closeBtn) return;

    const parent = closeBtn.closest('.rv-nguyenlan-sanpham');
    if (parent) {
        parent.classList.remove('is-expanded');
    }
});


  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ritavo-wood-product-slider"] && !Shopify.designMode) return;
  try {
    (function () {
    function getCols(slider) {
      var w = window.innerWidth;
      if (w <= 374)                return parseInt(slider.dataset.colsXs, 10) || 1;
      if (w >= 375 && w <= 767)   return parseInt(slider.dataset.colsSm, 10) || 2;
      if (w >= 768 && w <= 1279)  return parseInt(slider.dataset.colsMd, 10) || 3;
      if (w >= 1280 && w <= 1919) return parseInt(slider.dataset.colsLg, 10) || 4;
      return parseInt(slider.dataset.colsXl, 10) || 5;
    }

    function getRows(slider) {
      var w = window.innerWidth;
      if (w <= 374)                return parseInt(slider.dataset.rowsXs, 10) || 1;
      if (w >= 375 && w <= 767)   return parseInt(slider.dataset.rowsSm, 10) || 1;
      if (w >= 768 && w <= 1279)  return parseInt(slider.dataset.rowsMd, 10) || 2;
      if (w >= 1280 && w <= 1919) return parseInt(slider.dataset.rowsLg, 10) || 2;
      return parseInt(slider.dataset.rowsXl, 10) || 2;
    }

    function rebuildPages(slider) {
      var rows  = getRows(slider);
      var cols  = getCols(slider);
      var per   = rows * cols;
      var items = Array.from(slider.querySelectorAll('[data-rvs-page]'));

      items.forEach(function (item, idx) {
        item.dataset.rvsPage = Math.floor(idx / per);
      });

      return per;
    }

    function initSlider(slider) {
      if (slider.dataset.rvsReady) return;
      slider.dataset.rvsReady = '1';

      var current = 0;

      function getTotal() {
        var pages = new Set();
        slider.querySelectorAll('[data-rvs-page]').forEach(function (el) {
          pages.add(el.dataset.rvsPage);
        });
        return pages.size;
      }

      function goTo(page) {
        var total = getTotal();
        page = (page + total) % total;
        current = page;

        slider.querySelectorAll('[data-rvs-page]').forEach(function (item) {
          if (item.dataset.rvsPage === String(page)) {
            item.removeAttribute('hidden');
          } else {
            item.setAttribute('hidden', '');
          }
        });

        slider.querySelectorAll('[data-rvs-dot]').forEach(function (dot) {
          dot.classList.toggle('is-active', dot.dataset.rvsDot === String(page));
        });
      }

      function rebuildDots() {
      var dotsWrap = slider.querySelector('.rvs-nav__dots');
      if (!dotsWrap) return;

      var total = getTotal();
      var MAX   = 6;
      dotsWrap.innerHTML = '';

      if (total <= 1) return;

      /* Sliding window MAX dots quanh current */
      var half  = Math.floor(MAX / 2);
      var start = Math.max(0, current - half);
      var end   = Math.min(total - 1, start + MAX - 1);
      start     = Math.max(0, end - MAX + 1); /* điều chỉnh nếu end chạm biên */

      for (var i = start; i <= end; i++) {
        var btn = document.createElement('button');
        btn.className = 'rvs-nav__dot' + (i === current ? ' is-active' : '');
        btn.dataset.rvsDot = i;
        btn.setAttribute('aria-label', 'Trang ' + (i + 1));
        btn.addEventListener('click', (function (p) {
          return function () { goTo(p); };
        })(i));
        dotsWrap.appendChild(btn);
      }
    }

      function onResize() {
        rebuildPages(slider);
        var total = getTotal();
        if (current >= total) current = total - 1;
        goTo(current);
        rebuildDots();
      }

      var prevBtn = slider.querySelector('[data-rvs-prev]');
      var nextBtn = slider.querySelector('[data-rvs-next]');

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

      slider.querySelectorAll('[data-rvs-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.rvsDot, 10)); });
      });

      rebuildPages(slider);
      goTo(0);
      rebuildDots();

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(onResize, 150);
      });
    }

    document.querySelectorAll('[data-rvs-slider]').forEach(initSlider);
  })();
  } catch(e) { console.error(e); }
})();

})();
